<template>
  <section>
    <AboutCommitteesHeader />
    <AboutCommitteesIntro />
    <AboutCommitteesIndex />
    <AboutCommitteesIndexMore />
  </section>
</template>

<script>
import * as partials from './partials'

export default {
  name: 'AboutCommittees',
  components: { ...partials },
  provide() {
    return {
      wp: this.$wp.pages['about-committees'] || {}
    }
  },
  mounted() {
    console.log('about-committees', this.$wp.pages['about-committees'])
  }
}
</script>
